import StandardRestError from './Standard'

class LastAccountOwnerError extends StandardRestError {
  static CODE = 'LAST_ACCOUNT_OWNER'

  constructor(
    message = 'Cannot remove the last owner of the account.',
    status = 409,
    body = {},
  ) {
    super(message)
    this.status = status
    this.body = body
  }
}

export default LastAccountOwnerError
